import React from "react";
import { StepBack } from "lucide-react";
// import { createIcons, arrowBigRightDash } from "lucide-react";

function BackButton({ handleBackButton }) {
  return (
    <div>
      <button
        onClick={handleBackButton}
        className="  
          bg-yellow-500  hover:bg-yellow-600 flex justify-center items-center 
          rounded-full text-3xl text-white w-14 h-8"
      >
        <StepBack />
      </button>
    </div>
  );
}

export default BackButton;
